/* eslint-disable no-param-reassign */
import SockJSClient from "sockjs-client";
import { v4 } from "uuid";
var protocol = window.location.protocol;

// Python 编辑器(本地编辑器)的协议是 file, 需要更换为 https
if (protocol.includes("file:")) {
  protocol = "https:";
}
let SOCK_URL = `${protocol}///pusher-qa.xiguacity.cn`;
if (
  process.env.DEP_ENV === 'prod' ||
  window.location.protocol.includes("file:")
) {
  SOCK_URL = `${protocol}//pusher.xiguacity.cn`;
}
// SOCK_URL 从 localStorage 里面获取方便测试
SOCK_URL = window.localStorage.SOCK_URL || SOCK_URL;

// 获取随机数
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1) + min);
}

// 最大重连次数
const DEFAULT_MAX_RECONNECT_TIMES = 3;
const HEARTBEAT_INTERVAL = 25 * 1000;
// 重连延迟 随机 60-100 s
const RECONNECT_DELAY = getRandomInt(60, 100) * 1000;
// 心跳消息
const HEARTBEAT_FRAME = 'h';

class SockJS {
  constructor({ onmessage = () => {}, studentId }) {
    if (!studentId) {
      throw new Error("[im sockjs error] student id must be provided");
    }

    this.studentId = studentId;
    this.client = this.createClient();
    this.reconnectTimes = 0;
    this.onmessage = onmessage;
    this.monitorHeartbeatHandler = null;
  }

  createClient() {
    const client = new SockJSClient(this.sockUrl, null, {
      transports: ["websocket", "xhr-polling"],
      sessionId: v4,
    });
    client.onopen = this._onopen;
    client.onmessage = this._onmessage;
    client.onclose = this._onclose;
    return client;
  }

  get sockUrl() {
    return `${SOCK_URL}/pusher?appId=8888&userId=${this.studentId}`;
  }

  /* 在 ${RECONNECT_DELAY}s 随机时延后重连
   * 达到最大重试次数后放弃重连
   * ${RECONNECT_DELAY}s（考虑网络时延） 之内未收到心跳 或 连接断开均会触发重连
   */
  reconnect = (reason = "") => {
    // 防止同时触发心跳和 onclose 的重连
    window.clearTimeout(this.monitorHeartbeatHandler);
    if (this.reconnectTimes === DEFAULT_MAX_RECONNECT_TIMES) {
      throw new Error(
        `[im sockjs error] max reconnect times reached (${DEFAULT_MAX_RECONNECT_TIMES} times), reconnect reason: ${reason}`
      );
    }

    if (this.reconnectTimes < DEFAULT_MAX_RECONNECT_TIMES) {
      this.reconnectTimes += 1;
      window.setTimeout(() => {
        this.client = this.createClient();
        // 连接后重新拉去一次消息
        this.onmessage();
      }, RECONNECT_DELAY);
    }
  };

  _onopen = () => {
    // 连接成功后重连次数归 0
    this.reconnectTimes = 0;
    this.monitorHeartbeatHandler = setInterval(
      () => this.client.send(HEARTBEAT_FRAME),
      HEARTBEAT_INTERVAL
    );
  };

  _onmessage = (e) => {
    if (typeof this.onmessage !== "function") {
      throw new Error(
        `[im sockjs error] onmessage should be type of function, but got ${typeof this
          .onmessage}`
      );
    }
    this.onmessage(e);
  };

  _onclose = () => {
    this.reconnect("Connection Close");
  };
}

export default SockJS;
